// 模板
// {
//   type: 'paragraph',
//   value: '12月3日，工信部发布了《新能源汽车产业发展规划（2021-2035年）》（征求意见稿）。消息一出，新能源汽车板块股价大涨。'
// },
// {
//   type: 'image',
//   url: 'https://f12.baidu.com/it/u=3562263668,2806886095&fm=173&app=49&f=JPEG?w=640&h=360&s=EDE3A20B2E0140C6909552D703001094&access=215967316'
// },
// {
//   type: 'link',
//   value: '转载信息来源：第一财经',
//   url: 'https://mbd.baidu.com/newspage/data/landingshare?pageType=1&isBdboxFrom=1&context=%7B%22nid%22%3A%22news_10317939302728739220%22%2C%22sourceFrom%22%3A%22bjh%22%7D'
// }

const articles = [
  {
    key: '837434',
    creactTime: '1期 2019-12-16',
    title: '评论：2025年新能源汽车占比25% 目标是否激进存争议',
    label: '2019/12/16 18:46:48 优与科技',
    data: [
      {
        type: 'paragraph',
        value: '12月3日，工信部发布了《新能源汽车产业发展规划（2021-2035年）》（征求意见稿）。消息一出，新能源汽车板块股价大涨。'
      },
      {
        type: 'paragraph',
        value: '该征求意见稿中指出，到2025年，新能源汽车市场竞争力明显提高，动力电池、驱动电力、车载操作系统等关键技术取得重大突破，新能源汽车新车销量占比达到25%左右，智能网联汽车新车销量占比达到30%，高度自动驾驶智能网联汽车实现限定区域和特定场景应用。此外，纯电动乘用车新车平均电耗2025年降至12.0千瓦时/百公里，插电式混合动力（含增程式）乘用车新车平均油耗降到2.0升/百公里。'
      },
      {
        type: 'paragraph',
        value: '该征求意见稿中指出，到2025年，新能源汽车市场竞争力明显提高，动力电池、驱动电力、车载操作系统等关键技术取得重大突破，新能源汽车新车销量占比达到25%左右，智能网联汽车新车销量占比达到30%，高度自动驾驶智能网联汽车实现限定区域和特定场景应用。此外，纯电动乘用车新车平均电耗2025年降至12.0千瓦时/百公里，插电式混合动力（含增程式）乘用车新车平均油耗降到2.0升/百公里。'
      },
      {
        type: 'paragraph',
        value: '目标能否实现'
      },
      {
        type: 'paragraph',
        value: '值得注意的是，与此前的网传版本不同的是，《规划》意见稿将新能源汽车年销量占比从此前网传版本的20%提升至25%，同时去掉2030年的发展目标，即到2030年，新能源汽车形成市场竞争优势，销量占当年汽车总销量的40%，有条件自动驾驶智能网联汽车销量占比70%。'
      },
      {
        type: 'image',
        url: 'https://f12.baidu.com/it/u=3562263668,2806886095&fm=173&app=49&f=JPEG?w=640&h=360&s=EDE3A20B2E0140C6909552D703001094&access=215967316'
      },
      {
        type: 'paragraph',
        value: '日前，北汽集团董事长徐和谊在2019海纳川全球客户关系与市场发展论坛上透露，对于征求意见稿的讨论，大家主要关注的焦点之一是产业发展的阶段性目标是否恰当。徐和谊表示，此前大家对于新能源汽车产业目标的设定存在争议。部分行业人士认为，对于新能源汽车这一新兴业态来说，把阶段性目标定高有利于拉动产业的高速发展，但也有观点不赞成将目标设定得过于激进。“我看支持目标定高一些的人可能最终会’获胜’，我个人是希望阶段性目标能定低一些，不要太激进。”徐和谊表示。'
      },
      {
        type: 'paragraph',
        value: '“2025年的目标是近期有机会去实现的一个目标。因为补贴退坡等因素，短期内新能源车出现调整，曾提出的2020年销量占比达到10%的目标都有一定的难度，所以2025年销量占比25%的目标要想实现肯定要加速去推动。在短期出现一定压力情况下，未来几年要通过对产业引导、市场激发推动新能源汽车的发展，这块儿应该是政府会努力要去做的，也存在很大的机会。所以，政府在制定2025年目标时既会留有一定的余地，又会是行业短期内努力的方向，这个目标的制定是比较合适的。”乘联会秘书长崔东树对第一财经记者表示，比较远期的目标受技术突破等这些变化的影响比较大，不确定性也较大，所以5年的短期目标设定是比较务实的做法。'
      },
      {
        type: 'paragraph',
        value: '中国汽车工业协会副秘书长姚杰则向第一财经记者表示，在此前的很长一段时间，新能源汽车市场主要是由政策来主导，并高度依赖于补贴等传统扶持政策；而在目前的《规划》中，国家已经为传统补贴退坡后市场打下了一个重要的政策基调，为中国汽车产业提供了一个奋斗及创新的大方向，与此同时，经过了修订之后的《规划》，删除了2030年的发展目标，一方面显得更加务实，同时也为未来可能发生的市场变化留下了更多余地。'
      },
      {
        type: 'paragraph',
        value: '“此外，针对插电式混合动力汽车也进行了相关的规范，以及国家在此前推出的针对合资车企的双积分制度改革，也从另一方面有效地体现国家对于新能源汽车行业本身处于一种灵活的态度。”姚杰表示。'
      },
      {
        type: 'paragraph',
        value: '华金证券在一份研报中指出，在这个时点启动新一轮的产业规划的编制，主要是因为《节能与新能源汽车产业发展规划（2012-2020年）》已经接近尾声，相关目标已经基本达成，规划对新能源车产业的发展起到至关重要的作用也不言而喻。规划落地后将成为新能源车下一个蓬勃发展的十年的纲领性文件，长期利好新能源车产业发展。'
      },
      {
        type: 'paragraph',
        value: '鲶鱼效应'
      },
      {
        type: 'paragraph',
        value: '在政策支持等因素下，近年来新能源汽车发展较快。中国汽车工业协会发布的数据显示，今年1~10月新能源汽车累计销量为94.7万辆，同比增加10.1%。尽管新能源汽车整体跑赢大市，但增速已大幅放缓。此外，受补贴因素影响，自今年7月份以来，新能源汽车已出现连续4个月同比下滑的状况。中汽协也已将2019年新能源汽车销量目标由160万辆下调至140万辆。'
      },
      {
        type: 'paragraph',
        value: '上汽集团董事长陈虹在今年全国两会上甚至公开表示，到2020年购置补贴取消后，若无其他政策跟进，由于新能源汽车购置成本大幅上涨，很可能导致中国新能源汽车市场出现40%左右的“断崖式”下滑，特别是纯电动汽车受到的冲击更大，市场份额可能下滑50%左右。'
      },
      {
        type: 'paragraph',
        value: '由于补贴政策对新能源汽车影响较大，徐和谊此前就透露，未来对新能源产业是否还要有政策性的支持是大家对征求意见稿关注的一大焦点。他表示，目前行业大部分人认为还需要政策支持，但这不是最后结论。他还提到，如果推出相关政策，政策的导向则可能由新能源汽车销售环节转向消费者用车环节，包括基础设施的继续完善等。而此次正式征求意见并未提及补贴问题，不过提出了完善新能源汽车购置税等税收优惠政策，优化分类交通管理及金融、保险等支持政策，破除地方保护，建立统一开放公平的市场体系；鼓励地方政府加大公共服务，公共出行等领域车辆运营支持力度，给予新能源汽车通行、使用等优惠政策。此外，意见稿还提出完善双积分，建立与碳交易市场衔接机制。'
      },
      {
        type: 'paragraph',
        value: '“虽然今年新能源汽车在下半年连续四个月负增长，全年下来预估整体增长率会持平或略有上升。但看待新能源汽车的发展，更应该看整体的方向、战略以及趋势，新能源汽车的发展已不可逆转，随着国际品牌进入中国市场，会促进整个产业快速发展。”北汽新能源总经理马仿列对第一财经记者表示。'
      },
      {
        type: 'paragraph',
        value: '近两年来，外资车企不断加快在新能源领域的布局。奥迪、奔驰、雷克萨斯等多家车企的首款纯电动车已经在国内上市；而在刚刚结束的广州车展期间，大众、丰田、现代等跨国车企也宣布其新能源汽车战略。'
      },
      {
        type: 'paragraph',
        value: '按照规划，2023年宝马集团将提供25款电动车型，其中超过一半为纯电动车型。奥迪计划到2025年推出30多款电气化车型，其中20款将是纯电动车。奔驰则提出到2030年，电动车型将占据新车销量一半以上的份额。根据大众发布的“RoadmapE”规划，到2025年，大众旗下各品牌将推出80余款全新电动车型，包括50款纯电动车型及30款插电式混合动力车型。此外，特斯拉也正加快推进国产化。'
      },
      {
        type: 'paragraph',
        value: '韩国汽车产业协会运营委员长金泰年向第一财经记者表示，从此前来看，许多包括韩系在内的跨国车企在中国生产新能源汽车，许多因素是受到“双积分”政策等政策层面的影响，而随着中国政府在新能源汽车产业发展及市场层面推出发展规划，这也有效提高更多跨国车企发展新能源汽车的信心，并有利于提高跨国车企的投资力度，与本土车企共同开发这个产业的潜力。'
      },
      {
        type: 'paragraph',
        value: '博世中国总裁陈玉东也认为，中国政府选择在补贴退坡之际发布新一轮新能源汽车的发展规划，并提出具体时间点及目标，有利于增强外资零部件企业未来在华投资的信心，进而加大研发投资来推动新能源汽车的生产成本下降及大众化进程。'
      },
      {
        type: 'paragraph',
        value: '“政府加速推进新能源汽车发展将会是一个比较大的趋势，包括推进核心企业、产业链、商业模式发展等方面，2025年目标实现仍存在很大的机会。”崔东树对记者表示，意见稿提出了加强知识产权保护，这对外资企业在中国发展新能源车奠定了一个良好的基础，而内外资共同发展对新能源汽车目标实现提供了较大的机会。”崔东树表示，外资车企没进入的时候，市场竞争不充分，从而导致成本偏高，消费热情也不高，外资企业进入可能会形成鲶鱼效应，对降低成本有巨大的促进作用。'
      },
      {
        type: 'paragraph',
        value: '技术路线之争'
      },
      {
        type: 'paragraph',
        value: '此次意见稿还明确，将深化“三纵三横”研发布局。以纯电动汽车、插电式混合动力（含增程式）汽车、燃料电池汽车为“三纵”，布局整车技术创新链；以动力电池与管理系统、驱动电机与电力电子、网联化与智能化技术为“三横”，构建关键零部件技术供给系统。'
      },
      {
        type: 'image',
        url: 'https://f11.baidu.com/it/u=1958115874,1796683479&fm=173&app=49&f=JPEG?w=640&h=360&s=9F23F201861705C858887D0B0300A0C0&access=215967316'
      },
      {
        type: 'paragraph',
        value: '在新能源汽车方面，当前仍然以纯电动汽车为主流，而混合动力汽车销量也在逐步提升。对于燃料电池汽车，目前仍处于初级阶段。乘联会发布的9月份数据显示，合资品牌新能源插混车型9月同比增长80%，而自主品牌插混却同比下降了60%。也就是说，合资车企在混合动力车型方面正在发力。而截止2019年10月，工信部发布的《道路机动车辆生产企业及产品（第324批）》公告中，氢燃料电池车型共135款，包括客车98款，货车36款，轿车1款。'
      },
      {
        type: 'paragraph',
        value: '而在智能网联汽车方面，十一届中国猎车榜发布的《报告》显示，2018年智能网联新车型渗透率达到31.1%，相较2016年增长近5倍；2018年中国品牌智能网联新车型渗透率达到35.3%，相较2016年增长15倍。值得一提的是，智能网联功能正由高端、豪华车型向普通车型渗透，预计2019年智能网联汽车潜在客户下单渗透率将达到36.4%。'
      },
      {
        type: 'paragraph',
        value: '“纯电动仍然是核心方向，氢燃料汽车在乘用车方面目前还不适合发展。纯电动和混合动力汽车会形成一定的竞争。”崔东树对记者表示。'
      },
      {
        type: 'paragraph',
        value: '上海工程技术大学机械与汽车工程学院教师刘淼认为，新能源汽车的发展固然是大方向，但中国本土的新能源汽车在“三电技术”及工业化水平方面仍存在一定的局限性，尤其是在成本层面，许多新能源汽车更是“造一辆、亏一辆”。新能源汽车应当通过发挥规模效应，降低生产成本，进而脱离政策推动市场的目前形势。'
      },
      {
        type: 'paragraph',
        value: '宝马中国总裁刘智不久前在接受第一财经记者采访时则表示，目前新能源行业的困境确实存在，短期的困难和调整不能改变一个行业长期发展的趋势，这是很自然的现象，宝马等传统车企的进一步发力会把电动车整体水平进一步拉高。“新能源业务就像一场马拉松，马拉松是综合实力长期的体现，不计较短时间内的快慢。”刘智表示，这两年宝马主推的新能源车型是插电式混合动力车型，在可预计的将来插电式混合动力车型有很宽广的应用空间。'
      },
      {
        type: 'paragraph',
        value: '北京现代副总经理樊京涛也向第一财经记者表示，从目前的市场情况来看，很难预估哪一类路线能够最终成为受到消费者认可的路线，为此作为在新能源领域进入市场较晚的合资车企，应当凭借其积累多年的技术优势，在纯电、插电混动等多个领域同时进行准备，并为消费者提供更多的选择，进而在整个新能源领域占据主导权。'
      },
      {
        type: 'link',
        value: '转载信息来源：第一财经',
        url: 'https://mbd.baidu.com/newspage/data/landingshare?pageType=1&isBdboxFrom=1&context=%7B%22nid%22%3A%22news_10317939302728739220%22%2C%22sourceFrom%22%3A%22bjh%22%7D'
      }
    ]
  },
  {
    key: '837433',
    creactTime: '1期 2019-12-16',
    title: '动力电池成本大跳水，全球电动车或明年迎来真正热潮？',
    label: '2019/12/16 18:46:48 优与科技',
    data: [
      {
        type: 'image',
        url: 'https://f11.baidu.com/it/u=3736167598,2295011588&fm=173&app=49&f=JPEG?w=640&h=360&s=3F5A0FCA73611EAEC2B1011103005092&access=215967316'
      },
      {
        'type': 'paragraph',
        'value': '最新研究指出，电动车动力电池的价格于今年下降了13%，到2023年将突破每千瓦时100美元的目标。'
      },
      {
        'type': 'paragraph',
        'value': '尽管从技术上来讲，电动车从2010年到现在还没有像某些人所预期的那样流行到“起飞”，但有一些纯粹的经济学家则发表观点称，从2020年开始将是电动车迎来市场热潮的真正时期。'
      },
      {
        type: 'image',
        url: 'https://f10.baidu.com/it/u=2922424749,3435457931&fm=173&app=49&f=JPEG?w=640&h=424&s=039A642363874AE7465429DE0100C0A3&access=215967316'
      },
      {
        'type': 'paragraph',
        'value': '支持他们这一推论的主要因素就是电动车最重要的部件——动力电池的价格正在因技术的进步不断下降。从2010年到2019年，以电池组整体来看，锂离子电池的价格已从每千瓦时1100美元降至了现在的每千瓦时156美元，其整体降幅高达87％。事实上仅从去年到今年，其成本价就降低了13％。'
      },
      {
        'type': 'paragraph',
        'value': '这些数据是彭博新能源财经（BNEF）最近发布的年度报告中的一部分。该报告还指出，我们将在2023年之前实现100美元每千瓦时的目标。'
      },
      {
        type: 'image',
        url: 'https://f11.baidu.com/it/u=650004820,1827168378&fm=173&app=49&f=JPEG?w=640&h=426&s=271019CFD60300E64BB528290300C012&access=215967316'
      },
      {
        'type': 'paragraph',
        'value': '电池组不但是电动车最重要的部件组成，它通常也是电动车中最昂贵的部件。到目前为止，随着动力电池的价格在不断下探，汽车制造商已经开始决定为它们的电动车增加更多的电池容量。而且随着基础设施的不断发展，电池容量适中，且价格更低的电动车仍有很大的市场潜力。'
      },
      {
        type: 'image',
        url: 'https://f12.baidu.com/it/u=724727444,1720991701&fm=173&app=49&f=JPEG?w=640&h=409&s=1C287433738E6F4756FDA9C40100E0A3&access=215967316'
      },
      {
        'type': 'paragraph',
        'value': '就在两年前的2017年，锂离子汽车电池组的平均价格还在209美元每千瓦时的时候BNEF就做过预测，到2025年时锂离子汽车电池组的价格将跌破100美元每千瓦时。'
      },
      {
        'type': 'paragraph',
        'value': '现在新的预测为什么会比之前预计的更早？其部分原因在于，电池订单的规模已经变得更大了，这代表着汽车制造商对全球电动车市场将继续增长的信心投票。'
      },
      {
        type: 'image',
        url: 'https://f10.baidu.com/it/u=2989393575,3901388293&fm=173&app=49&f=JPEG?w=640&h=307&s=82966422C521790B38F6D943020070F9&access=215967316'
      },
      {
        'type': 'paragraph',
        'value': 'BNEF现在预计，到2024年基于电池组的电池价格将跌破每千瓦时100美元的关口。报告还指出，到2030年时电池价格将继续下降，预计将达到每千瓦时61美元，不过这后一个目标的不确定性就要大得多了。'
      },
      {
        'type': 'paragraph',
        'value': 'BNEF估计全球电池市场的规模每年为1,160亿美元，这还不包括对供应链的投资。但是，随着电池和电池组价格的下降，消费者将获得比现在更多的实惠。'
      },
      {
        type: 'image',
        url: 'https://f10.baidu.com/it/u=1927864335,1572169142&fm=173&app=49&f=JPEG?w=640&h=424&s=4B80EC0850AB4AA610B469F70100C022&access=215967316'
      },
      {
        'type': 'paragraph',
        'value': '随着汽车制造商对电动车设计的不断简化，使其成为基于标准化电池和模块的基础，这些电池和模块现在可以做到在平台内按比例放大或缩小，就比如大众最新推出的MEB电动车架构。新平台还可以对一些电动车的辅助部件，比如冷却系统同样实现标准化，使其价格更便宜。'
      },
      {
        type: 'image',
        url: 'https://f12.baidu.com/it/u=4248302786,3764646263&fm=173&app=49&f=JPEG?w=640&h=426&s=1FA5CD0407574DDE44DD24D3030080BF&access=215967316'
      },
      {
        'type': 'paragraph',
        'value': '在电动车从2010年发展到现在的近十年时间，其工厂和制造成本也在不断下降，并且这个下降也超出了之前的预期。为了降低运输成本，并尽可能避免进口关税，越来越多的电池制造商正在按地区建立工厂。比如，作为全球第一大新能源市场的中国，除了本土电池制造商宁德时代与比亚迪等，国外的电池制造商如韩国SK创新就在江苏常州建立了新电池工厂；而松下在中国则有大连和苏州的两家电池工厂；LG化学除了在南京的电池工厂外还计划在天津建厂。'
      },
      {
        'type': 'paragraph',
        'value': '至于新能源车的第二大市场美国方面，SK创新正在乔治亚州建设一家工厂，并为大众在田纳西州的电动车生产提供原料；LG化学和通用汽车则刚刚宣布要在俄亥俄州建立一家合资工厂；我国的电池巨头宁德时代也考虑要在美国选址建厂。'
      },
      {
        type: 'image',
        url: 'https://f10.baidu.com/it/u=744450915,1198532949&fm=173&app=49&f=JPEG?w=640&h=426&s=BA04DE040C515ECA3439C0D6030060A3&access=215967316'
      },
      {
        'type': 'paragraph',
        'value': '在本世纪的下半叶，扩大规模和实现标准化带来的收益可能会有所减少，而汽车制造商与电池制造商的更多收益则可能来自更多现有设施的扩展，制造设备的改造以及与材料相关的升级改进。'
      },
      {
        type: 'image',
        url: 'https://f11.baidu.com/it/u=2287813309,470793245&fm=173&app=49&f=JPEG?w=640&h=354&s=C8C141840BA1884F16D97D0B0300A0C0&access=215967316'
      },
      {
        'type': 'paragraph',
        'value': '电池价格的持续下跌影响范围广泛，且已超出了乘用车的范畴。BNEF指出，这使得商业运输工具的电动化更具吸引力。'
      },
      {
        type: 'image',
        url: 'https://f10.baidu.com/it/u=2269343382,1023861601&fm=173&app=49&f=JPEG?w=640&h=445&s=572607E0564A374F649AC100030060DB&access=215967316'
      },
      {
        'type': 'paragraph',
        'value': '该公司预计，在成本不断下降的情况下，汽车制造商可能很快就会面临新的选择——更长的产品生命循环周期或者更低的成本。当大容量动力电池就像现在那些价格适中的电脑存储器那样得到普遍应用时，这种选择可能就会成为区分高档车与普通车之间的一个更好依据了。【END】'
      },
      {
        type: 'link',
        value: '转载信息来源：天天骑车APP',
        url: 'https://mbd.baidu.com/newspage/data/landingshare?pageType=1&isBdboxFrom=1&context=%7B%22nid%22%3A%22news_9374095276705821975%22%2C%22sourceFrom%22%3A%22bjh%22%7D'
      }
    ]
  },
  {
    key: '837430',
    creactTime: '1期 2019-12-16',
    title: '新能源汽车保值率较低，残值管理成关键',
    label: '2019/12/16 18:46:48 优与科技',
    data: [
      {
        'type': 'paragraph',
        'value': '优与科技保值率数据显示，近三年主流新能源汽车平均保值率仅为35.2%，是什么原因导致了新能源二手车在市场上的表现如此惨淡？'
      },
      {
        'type': 'subtitle',
        'value': '新能源二手车市场表现'
      },
      {
        'type': 'paragraph',
        'value': '根据中国汽车流通协会数据显示，中国二手车整体的月度成交量达到100万辆以上，但新能源二手车月度成交量仅仅在15万辆左右。'
      },
      {
        type: 'image',
        url: 'https://mmbiz.qpic.cn/mmbiz_png/5Hme4afMicoG18R0GwTbX6yURH9ojcSYHiaLWcLSPCWiaPLN9MK2KYxUwWu5iaPOwNOK9R0ticf7Koc98b4IbuGSEVw/640?wx_fmt=png'
      },
      {
        'type': 'subtitle',
        'value': '新能源二手车保值率较低'
      },
      {
        'type': 'paragraph',
        'value': '单从品牌整体而言，除了特斯拉、蔚来和比亚迪保值率维持在40%以上之外，其他品牌车型三年车龄平均保值率在30%左右。从具体车系数据来看，除了特斯拉Model S之外，其他市场上主流的纯电动车三年车龄的保值率仅为30%左右。'
      },
      {
        type: 'image',
        url: 'https://mmbiz.qpic.cn/mmbiz_png/5Hme4afMicoG18R0GwTbX6yURH9ojcSYHu0u0hSzCNgSic6giaQico1b5goVLDicRlR53UyaMDWtb7d18fs9kNpTv8w/640?wx_fmt=png'
      },
      {
        'type': 'paragraph',
        'value': '具体是什么原因导致了新能源二手车市场目前过低的残值，以及消费者不能接受的主要顾虑。'
      },
      {
        'type': 'subtitle',
        'value': '1.新能源二手车市场体量较小'
      },
      {
        'type': 'paragraph',
        'value': '众所周知，多数燃油车的置换周期基本在5-6年左右，而新能源汽车在近几年才开始逐渐发展，目前还没有全面进入消费者的置换周期，直接导致市场需求量有限，既然供大于需，价格自然就提不上去，这也就导致新能源车的二手车市场进行恶性循环状态，越是没人买，价格就越低。'
      },
      {
        'type': 'subtitle',
        'value': '2.新能源二手车评估体系不够完善'
      },
      {
        'type': 'paragraph',
        'value': '不管是新车还是二手车，消费者最关心的还是质量。对于传统燃油车来说，其车辆检测体系和技术都已经非常成熟，但对于新能源车来说，如何判定品质的好坏就成了一个大难题。新能源汽车的三电系统不好评估，尤其是动力电池的衰减很难预估，目前还是缺乏合理的新能源二手车评估体系，因此消费者在面对新能源二手车选择的时候，就会显得疑虑重重。'
      },
      {
        'type': 'subtitle',
        'value': '3.动力电池储能技术的发展'
      },
      {
        'type': 'paragraph',
        'value': '3年前，纯电动汽车的续航里程一般在150公里左右，随着动力电池技术的不断升级迭代，今年上市的新能源车型中，绝大部分续航里程都可以达到400公里以上，甚至是500公里，那么，几年前的低续航车型自然难以有市场。'
      },
      {
        type: 'image',
        url: 'https://mmbiz.qpic.cn/mmbiz_png/5Hme4afMicoG18R0GwTbX6yURH9ojcSYH4ibiaIibHMG6JqGVss7icHNBE1pN15ZthyV7J3eDqPzh0aQ7Z1lBmy7HSQ/640?wx_fmt=png'
      },
      {
        'type': 'subtitle',
        'value': '新能源车残值管理路径'
      },
      {
        'type': 'paragraph',
        'value': '在新能源二手车残值普遍较低的情况，如何稳定和提高残值就成了各个主机厂面临的问题，那么合理的进行残值管理就成了稳定和提高残值的关键路径。'
      },
      {
        type: 'image',
        url: 'https://mmbiz.qpic.cn/mmbiz_png/5Hme4afMicoG18R0GwTbX6yURH9ojcSYHDwkicPv2ibpQicMS8hGYSyXN9IUApHHN4cXhaqjykDfaic0iaBe0IwPXeHg/640?wx_fmt=png'
      },
      {
        'type': 'subtitle',
        'value': '特斯拉保值回购服务'
      },
      {
        'type': 'paragraph',
        'value': '2015年4月13日，特斯拉宣布在中国推出保值承诺服务，即在车主贷款购车三年后，若车主有车辆回购需求，特斯拉在经过条件审核后会以约50%的购入价格回购车主手中的Model S，主要目的是为了稳定Model S的保值率，消除消费者的购车顾虑，进而促进Model S的推广和销售。该项服务已于2016年7月1日终止。'
      },
      {
        type: 'image',
        url: 'https://mmbiz.qpic.cn/mmbiz_png/5Hme4afMicoG18R0GwTbX6yURH9ojcSYHaaZAzz1J6YXxXtXnMMib1wCOept69puZ1Luev9wRbLMLzRaaUvKX0hA/640?wx_fmt=png'
      },
      {
        'type': 'subtitle',
        'value': '北汽推出“北汽租售通”服务'
      },
      {
        'type': 'paragraph',
        'value': '“北汽租售通”作为一款集租赁服务、消费金融、新车销售、售后回购、残值保障五位一体的全新出行解决方案，有效解决了当前消费者用车的一系列痛点。'
      },
      {
        type: 'image',
        url: 'https://mmbiz.qpic.cn/mmbiz_png/5Hme4afMicoG18R0GwTbX6yURH9ojcSYHFUXHYTOs3nheJ0nRsvkOEgoJPiaOmicdAiaBg7kxNn2XyZoj7oydKK3OQ/640?wx_fmt=png'
      },
      {
        'type': 'subtitle',
        'value': '威马认证二手车及用户关怀计划'
      },
      {
        'type': 'paragraph',
        'value': '威马汽车发布智选官方认证二手车品牌，企业通过直接切入车辆收购、二手车官方翻新、电商销售以及二手车租购等环节，为用户提供优质的二手车源，提升车辆保值率。'
      },
      {
        'type': 'paragraph',
        'value': '威马汽车推出用户关怀计划，解决电池衰减与残值焦虑，降低未来换购成本，为用户提供车辆全生命周期的价值管理和保障。'
      },
      {
        type: 'image',
        url: 'https://mmbiz.qpic.cn/mmbiz_png/5Hme4afMicoG18R0GwTbX6yURH9ojcSYHflECIyvmnExHuO5gnpc5qiaVvLK3a7m1jrotvVxcw92MCIY6uQcrQpg/640?wx_fmt=png'
      },
      {
        'type': 'paragraph',
        'value': '随着新产品不断推出和电池技术的不断迭代升级，插电混动和纯电动的旧车很难保值，想要逐步稳定并提高新能源二手车残值，则必须由厂家主动引导，通过变革经营模式、推动渠道创新等方式消除消费者对于动力电池衰减和续航的顾虑，逐步提高品牌影响力，进而达到稳定和提高残值的目的。'
      }
    ]
  }
]

export default articles
